import React, { useEffect, useState } from 'react'
import { Col, message, Modal, Row } from 'antd'
import './CreateBucketVersionModal.scss'
import DataPicker from 'components/ui/dataEntry/inputs/DatePicker'
import moment from 'moment'

const UpdateBucketVersionModal = ({
  visible,
  onOk,
  onCancel,
  loading,
  dateFormat = 'DD MMM YYYY, HH:mm:ss',
  basicDateRangeDetails
}) => {
  const [basicStartDate, setBasicStartDate] = useState(null)
  const [basicEndDate, setBasicEndDate] = useState(null)

  useEffect(() => {
    if (!basicDateRangeDetails) return
    setBasicStartDate(basicDateRangeDetails.basicStartDate)
    setBasicEndDate(basicDateRangeDetails.basicEndDate)
  }, [basicDateRangeDetails])

  return (
    <Modal
      title='Update Schedule'
      visible={visible}
      onOk={() => {
        if (moment(basicEndDate).isBefore(moment(basicStartDate))) {
          message.warning('End date cant be before start date.')
          return
        }
        onOk({
          basicStartDate,
          basicEndDate
        })
      }}
      onCancel={onCancel}
      className='general-modal create-bucket-version-modal'
      okButtonProps={{
        loading
        // disabled: moment(basicEndDate).isBefore(moment(basicStartDate))
      }}
      width='1000px'
      okText='UPDATE'
    >
      <div className='create-bucket-version-wrapper'>
        <Row className='basic-date-picker' gutter={[24, 24]}>
          <Col span={8} className='input-field'>
            <label>Version Start Date </label>
            <DataPicker
              use12Hours={false}
              date={basicStartDate ? moment(new Date(basicStartDate), dateFormat).format(dateFormat) : null}
              // disabledDate={(selectedDate) => moment(selectedDate).isAfter(moment(basicStartDate))}
              // disabledTime={startDate ? () => this.disabledRangeTime('start') : () => this.disableTimeComplete()}
              dateFormat={dateFormat}
              placeholder='Select Start Date'
              allowClear
              onChange={(value) => {
                setBasicStartDate(value)
              }}
              showTime={{
                use12Hours: false,
                onAmPmChange: () => {},
                format: 'HH:mm:ss'
              }}
            />
          </Col>
          <Col span={8} className='input-field'>
            <label>Version End Date</label>
            <DataPicker
              use12Hours={false}
              date={basicEndDate ? moment(new Date(basicEndDate), dateFormat).format(dateFormat) : null}
              // disabledDate={getDisabledDate}
              // disabledTime={getDisabledTime}
              dateFormat={dateFormat}
              placeholder='Select End Date'
              allowClear
              onChange={(value) => {
                setBasicEndDate(value)
              }}
              showTime={{
                use12Hours: false,
                onAmPmChange: () => {},
                format: 'HH:mm:ss'
              }}
            />
          </Col>
        </Row>
        {/* <Divider />
        <p> ADVANCED SCHEDULING COMES HERE</p> */}
      </div>
    </Modal>
  )
}

export default UpdateBucketVersionModal
